// CommonInstallationsInfoModal.js
import { Modal, ModalHeader, ModalBody, ModalContent } from "@heroui/react";
import { useEffect } from "react";
import ElevatorInfoComponent from "./elevatorInfoComponent";

const ElevatorInfoModal = ({ isOpen, onClose, unit, building }: any) => {
  useEffect(() => {
    console.log("Building:", building);
    console.log("Unit:", unit);
  }, [building, unit]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="5xl"
      shouldBlockScroll={true}
      isDismissable={true}
      scrollBehavior="inside"
      backdrop="blur"
      className="p-8"
    >
      <ModalContent className="flex flex-col gap-4 font-normal text-neutral-primary">
        <ModalHeader className="flex flex-row items-center justify-between p-0 font-normal">
          <p>{unit?.id || building?.id} - Lift informatie</p>
        </ModalHeader>
        <ModalBody className="px-0">
          <ElevatorInfoComponent
            handleCloseParent={onClose}
            commonInstallationsInfo={
              unit
                ? {
                    ...unit?.commonInstallationsInfo,
                    unitId: unit?.id,
                }
                : {
                    ...building?.commonInstallationsInfo,
                    buildingId: building?.id,
                }
            }
            building={building}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ElevatorInfoModal;
